import { Injectable } from '@angular/core';

export interface ToastMessage {
  id: number;
  text: string;
  type: 'success' | 'error' | 'info';
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private messages: ToastMessage[] = [];
  private currentId = 0;

  get toastMessages(): ToastMessage[] {
    return this.messages;
  }

  showSuccess(text: string): void {
    this.addMessage(text, 'success');
  }

  showError(text: string): void {
    this.addMessage(text, 'error');
  }

  showInfo(text: string): void {
    this.addMessage(text, 'info');
  }

  removeMessage(id: number): void {
    this.messages = this.messages.filter(m => m.id !== id);
  }

  private addMessage(text: string, type: 'success' | 'error' | 'info'): void {
    this.currentId++;
    const newMessage: ToastMessage = {
      id: this.currentId,
      text,
      type
    };
    this.messages.push(newMessage);
    setTimeout(() => {
      this.removeMessage(newMessage.id);
    }, 3000);
  }
}